import { useState } from "react";
import { AiOutlineTrophy } from "react-icons/ai";
import { useSuspenseQuery } from "@tanstack/react-query";

import { getUsersRanking } from "~/data/dashboard/dashboard.service";

import { InputSearch } from "../shared/input";
import { UserAvatar } from "../shared/user-avatar";
import { useUser } from "../shared/queries/user-query";

export function RankingSection() {
  const [search, setSearch] = useState("");
  return (
    <section className="rounded-[20px] bg-white shadow-card p-5 pb-1">
      <div className="flex items-center gap-3 mb-5">
        <h2 className="font-alternative text-2xl font-semibold uppercase">
          Ranking
        </h2>
        <span className="py-px px-2 bg-[#D3D3D3] rounded text-sm font-alternative">
          Geral
        </span>
        <InputSearch
          className="ml-auto w-full max-w-[264px]"
          placeholder="Busque por nome"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
        />
      </div>

      <Ranking search={search} />
    </section>
  );
}

interface Props {
  search: string;
}
function Ranking({ search }: Props) {
  const { data: ranking } = useSuspenseQuery({
    queryKey: ["ranking"],
    queryFn: () => getUsersRanking(),
    staleTime: Infinity,
  });
  const rows = ranking.data.filter((it) =>
    it.user.name.toLowerCase().includes(search.toLowerCase())
  );
  const currentUser = useUser();

  return (
    <div>
      <header className="mr-[10px] px-5 flex items-center gap-[30px] mb-[10px] font-alternative text-[10px] leading-3 tracking-widest font-bold uppercase">
        <span className="pl-[10px]">
          <AiOutlineTrophy size={16} />
        </span>
        <span>Nome</span>
        <span className="ml-auto">Nota Geral</span>
      </header>
      <ol
        className="grid gap-[10px] overflow-y-auto mb-[10px]"
        style={{ gridAutoRows: 44, height: 44 * 3 + 10 * 2 }} // 3 rows
      >
        {rows.map(({ user }) => (
          <li
            key={user.id}
            className="flex items-center gap-5 py-1 px-4 bg-surface rounded-[10px]"
          >
            <div className="relative">
              <UserAvatar name={user.name} url={user.avatar_url} size={36} />
              <span className="h-4 w-4 inline-flex items-center justify-center font-alternative font-semibold text-[10px] absolute top-0 right-0 bg-yellow-500 rounded-full">
                {user.application_ranking}
              </span>
            </div>
            <span className="font-alternative text-base">Dr. {user.name}</span>
            <span className="ml-auto px-2 text-alternative-2 font-alternative text-lg font-medium">
              {user.avg_score.toFixed(1)}
            </span>
          </li>
        ))}
      </ol>

      <div className="flex items-center gap-5 py-1 px-4 bg-alternative-2/20 rounded-[10px] mr-[10px]">
        <div className="relative">
          <UserAvatar
            name={currentUser.name}
            url={currentUser.avatar_url}
            size={36}
          />
          <span className="h-4 w-4 inline-flex items-center justify-center font-alternative font-semibold text-[10px] absolute top-0 right-0 bg-yellow-500 rounded-full">
            {currentUser.application_ranking}
          </span>
        </div>
        <span className="font-alternative text-base">
          Dr. {currentUser.name}
        </span>
        <span className="ml-auto px-2 text-alternative-2 font-alternative text-lg font-medium">
          {currentUser.avg_score.toFixed(1)}
        </span>
      </div>
    </div>
  );
}
